import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getSecurityQuestions, validateSecurityAnswer } from '../../features/auth/service/auth_service';
import useUserContextStore from '../../store/userContextStore';
// PLACEHOLDER: replace with actual API calls
// const checkPasswordTemporary = async (param) => { GET /Home/CheckPasswordTemporary?param=... → returns [{ PasswordTemporary, ResetPasswordUniqueID }] }
// const getChallengePhrasesQuestions = async (param) => { GET /SecurityQuestions/GetChallengePhrasesQuestions?param=... → returns [{ ChallengePhraseId, ChallengePhrase }] }
// const validateChallengePhrase = async (userId, questionId, answer) => { GET /User/ValidateChallengePhrase?userId=...&questionId=...&cpanswer=... → returns true/false }
// const changeForgotPasswordContactValidate = async (param) => { GET /Home/ChangeForgotPasswordContactValidate?param=... → returns true/false }
// const getEncryptedString = async (value) => { GET /AdminContact/GetEncryptedString?encryptString=... → returns encrypted string }

const QUESTION_PHASE = {
    FIRST: 0,
    SECOND: 1,
    DONE: 2,
};

export const SecurityQuestionCheck = ({ }) => {
    const [questions, setQuestions] = useState([]);
    const [currentQuestion, setCurrentQuestion] = useState(null);
    const [firstQuestion, setFirstQuestion] = useState(null);
    const [answer, setAnswer] = useState('');
    const [phase, setPhase] = useState(QUESTION_PHASE.FIRST);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const globalUserContext = useUserContextStore((state)=> state.context)
    const setGlobalUserContext = useUserContextStore((state)=>state.setUserContext);
    const [context, setContext] = useState(globalUserContext);

    useEffect(()=>{
    if(globalUserContext){
      setContext(globalUserContext)
    }
  },[globalUserContext])
    useEffect(() => {
        loadQuestions();
    }, []);

    const getRandomQuestion = (list) => {
        return list[Math.floor(Math.random() * list.length)];
    };

    const getDistinctRandomQuestion = (list, excludeId) => {
        if (list.length === 1) return list[0];
        let picked;
        let attempts = 0;
        do {
            picked = getRandomQuestion(list);
            attempts++;
        } while (picked.ChallengePhraseId === excludeId && attempts < 4);
        return picked;
    };

    const loadQuestions = async () => {
        try {
            // REPLACE: actual API call
            const response = await getSecurityQuestions(atob(context.userId));
            const data = response.data || []; // placeholder

            if (data && data.length > 0) {
                setQuestions(data);
                const first = getRandomQuestion(data);
                setFirstQuestion(first);
                setCurrentQuestion(first);
            }
            else{
                setError("You have not set any security question, Please contact Admin");
            }
        } catch (e) {
            setError('Failed to load security questions.');
        } finally {
            setLoading(false);
        }
    };


    const handleSubmit = async () => {
        if (!answer.trim()) {
            setError('* Answer is required');
            return;
        }
        setError('');

        try {
            // REPLACE: actual API call
            const isValid = await validateSecurityAnswer(atob(context.userId), currentQuestion.challengePhraseId, answer);
            //const isValid = false; // placeholder

            if (phase === QUESTION_PHASE.FIRST) {
                if (isValid?.data) {
                    const second = getDistinctRandomQuestion(questions, firstQuestion.challengePhraseId);
                    setCurrentQuestion(second);
                    setAnswer('');
                    setPhase(QUESTION_PHASE.SECOND);
                } else {
                    setError('Question answer does not match. Please try again');
                }
            } else if (phase === QUESTION_PHASE.SECOND) {
                if (isValid?.data) {
                    setPhase(QUESTION_PHASE.DONE);
                    await handleRedirect();
                } else {
                    setError('Question answer does not match. Please try again');
                }
            }
        } catch (e) {
            setError('Validation failed. Please try again.');
        }
    };

    const handleRedirect = async () => {
        try {
            setContext(null);
            navigate(`/UserProfile/${context.userId}/password`, { replace: true });
        } catch (e) {
            console.log('error:',e)
        }
    };

    const handleKeyUp = (e) => {
        if (e.key === 'Enter') handleSubmit();
    };

    if (loading) return <div>Loading...</div>;
    if(!context) return null;
    return (
    <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: '120px'
    }}>
        <div style={{
        width: '600px',
        background: '#fff',
        padding: '30px',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>

        {/* Title */}
        <h3 style={{
            textAlign: 'center',
            marginBottom: '25px',
            color: '#1a237e'
        }}>
            Security Verification
        </h3>

        {/* Error */}
        {error && (
            <div style={{
            color: 'red',
            marginBottom: '15px',
            textAlign: 'center'
            }}>
            {error}
            </div>
        )}

        {/* Question */}
        <div style={{ marginBottom: '15px' }}>
            <label style={{ fontWeight: '600' }}>
            Question {phase + 1}
            </label>
            <div style={{ marginTop: '5px', color: '#333' }}>
            {currentQuestion?.challengePhrase}
            </div>
        </div>

        {/* Answer Input */}
        <div style={{ marginBottom: '20px' }}>
            <label style={{ fontWeight: '600' }}>Answer</label>
            <input
            type="password"
            className="form-control"
            placeholder="Enter your answer"
            value={answer}
            onChange={(e) => setAnswer(e.target.value)}
            onKeyUp={handleKeyUp}
            />
        </div>

        {/* Buttons */}
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '10px'
        }}>
            <button
            type="button"
            onClick={handleSubmit}
            style={{
                backgroundColor: '#1a237e',
                color: '#fff',
                padding: '8px 20px',
                border: 'none',
                borderRadius: '4px'
            }}
            >
            Go
            </button>
        </div>

        </div>
    </div>
    );
};